import { Controller } from '@hotwired/stimulus';
import i18n from '../init/i18n';

export default class extends Controller {
  connect() {
    const todaysBirthdays = this.#getTeamBirthdays();

    todaysBirthdays.forEach((member) => {
      console.log(i18n.t('happy_birthday', { name:  member.name }));
    });
  }

  #getTeamBirthdays() {
    const team = [
      { name: 'Eliot', birthday: '9-25' },
      { name: 'Lucien', birthday: '12-30' },
      { name: 'Virginie', birthday: '9-10' },
      { name: 'Léa', birthday: '6-3' },
      { name: 'Jullian', birthday: '8-9' },
      { name: 'Maya', birthday: '3-18' },
      { name: 'Christopher', birthday: '11-15' },
    ];

    return team.filter((member) => this.#isTodayBirthday(member.birthday));
  }

  #isTodayBirthday(birthday) {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const todayFormatted = `${month}-${day}`;

    return birthday === todayFormatted;
  }
}
